var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUpGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_up_grey",
    transform: "translate(0 24) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_64px_icon",
    "data-name": "64px icon",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_2",
    "data-name": "\\uC0AC\\uAC01\\uD615 2",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,24V0H24V24Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 21 L 21 3 L 3 3 L 3 21 L 21 21 M 24 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 24 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M4.439,0,0,4.617,4.439,9.235",
    transform: "translate(14.22 16.617) rotate(180)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUpGrey);
export default __webpack_public_path__ + "static/media/ico_up_grey.8b1bc19f1c30effaa1cd701ca729fea4.svg";
export { ForwardRef as ReactComponent };